// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coreControlReasonContainer {
  display: flex;
  flex-direction: column;
}
.alignCoreControl {
  display: flex;
  align-items: center;
  margin-bottom: 3.66vw;
}
.coreControlReasonIcon {
  width: 4.24vw;
  height: 4.24vw;
  background: #548aff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1.61vw;
}
.coreControlReasonIcon img {
  height: 50%;
}
.coreControlText {
}
.coreControlHeading {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1.17vw;
  line-height: 153.19%;
  /* identical to box height, or 25px */
  color: #000000;
}
.coreControlTitle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 0.87vw;
  line-height: 134.69%;
  /* or 1.17vw */
  width: 28.91vw;

  color: #6d6d6d;
}
@media only screen and (max-width: 767px) {
  .coreControlReasonContainer {
    padding-top: 30px;
    width: 90%;
  }
  .alignCoreControl {
    /* width: 100%; */
    align-items: flex-start;
  }
  .coreControlText {
    width: 90%;
  }
  .coreControlReasonIcon {
    width: 50px;
    height: 45px;
    margin-right: 20px;
    margin-top: 6px;
  }
  .coreControlReasonIcon img {
    width: 55%;
    height: 55%;
    object-fit: contain;
  }

  .coreControlHeading {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    font-family: Roboto;
    margin-bottom: 8px;
  }
  .coreControlTitle {
    font-size: 14px;
    width: 98%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/WebHomePage/Reusable/CoreControlReason.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;AACA;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,cAAc;;EAEd,cAAc;AAChB;AACA;EACE;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF","sourcesContent":[".coreControlReasonContainer {\n  display: flex;\n  flex-direction: column;\n}\n.alignCoreControl {\n  display: flex;\n  align-items: center;\n  margin-bottom: 3.66vw;\n}\n.coreControlReasonIcon {\n  width: 4.24vw;\n  height: 4.24vw;\n  background: #548aff;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 1.61vw;\n}\n.coreControlReasonIcon img {\n  height: 50%;\n}\n.coreControlText {\n}\n.coreControlHeading {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 1.17vw;\n  line-height: 153.19%;\n  /* identical to box height, or 25px */\n  color: #000000;\n}\n.coreControlTitle {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 0.87vw;\n  line-height: 134.69%;\n  /* or 1.17vw */\n  width: 28.91vw;\n\n  color: #6d6d6d;\n}\n@media only screen and (max-width: 767px) {\n  .coreControlReasonContainer {\n    padding-top: 30px;\n    width: 90%;\n  }\n  .alignCoreControl {\n    /* width: 100%; */\n    align-items: flex-start;\n  }\n  .coreControlText {\n    width: 90%;\n  }\n  .coreControlReasonIcon {\n    width: 50px;\n    height: 45px;\n    margin-right: 20px;\n    margin-top: 6px;\n  }\n  .coreControlReasonIcon img {\n    width: 55%;\n    height: 55%;\n    object-fit: contain;\n  }\n\n  .coreControlHeading {\n    font-weight: 600;\n    font-size: 16px;\n    color: #000000;\n    font-family: Roboto;\n    margin-bottom: 8px;\n  }\n  .coreControlTitle {\n    font-size: 14px;\n    width: 98%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
